// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__PFjku","category":"sidebar_category__Yvznf","sell_box":"sidebar_sell_box__r-W6Y"};